export default "__VITE_ASSET__bRH9h0mZ__"